import { useTranslation } from 'react-i18next';
import { GovIcon, GovMessage } from '@gov-design-system-ce/react';
import type { PageCode } from '@gov-nx/module/page';
import { useEPeticeDetailContext } from '@gov-nx/module/page';
import { Button, Dialog } from '@gov-nx/ui/web';
import { toDateReadable } from '@gov-nx/utils/common';

export interface EPetitionDetailViewProps {
	code: PageCode;
}

export const EPetitionExtend = ({ code }: EPetitionDetailViewProps) => {
	const { t } = useTranslation(code);
	const { petition, controls, setControls, ePetitionExtend } =
		useEPeticeDetailContext();

	return (
		<div>
			<GovMessage
				color="warning"
				type="subtle"
				icon={
					<GovIcon
						type="components"
						name="lightbulb-fill"
					/>
				}>
				<div className="flex flex-col gap-4 [ md:flex-row md:justify-between md:items-center ]">
					<p>
						{t('datum-uzavreni.status.epetice.detail', {
							namespace: code,
							closureDate: petition?.datumUkonceni
								? toDateReadable(petition.datumUkonceni)
								: null,
						})}
					</p>
					<Button
						onClick={() => {
							setControls({ isExtendModal: true });
						}}
						color="warning"
						type="solid"
						size="s"
						aria-label={t('akce.prodlouzit')}>
						{t('akce.prodlouzit')}
					</Button>
				</div>
			</GovMessage>

			<Dialog
				isOpen={controls.isExtendModal}
				onClose={() => setControls({ isExtendModal: false })}
				title={<h3>{t('modal.pole.prodlouzit')}</h3>}
				footer={
					<>
						<Button
							onClick={() => {
								petition?.id && ePetitionExtend.extendQuery.mutate(petition.id);
								setControls({ isExtendProcessing: true });
							}}
							isLoading={controls.isExtendProcessing}
							isDisabled={controls.isExtendProcessing}
							color="primary"
							type="solid"
							nativeType="button"
							size="m"
							aria-label={t('tlacitko.akce.prodlouzit')}>
							{t('tlacitko.akce.prodlouzit')}
						</Button>
						<Button
							onClick={() => setControls({ isExtendModal: false })}
							color="error"
							nativeType="button"
							size="m"
							type="outlined"
							aria-label={t('tlacitko.akce.neprodluzovat')}>
							{t('tlacitko.akce.neprodluzovat')}
						</Button>
					</>
				}>
				{t('modal.pole.chcete-prodlouzit')}
			</Dialog>
		</div>
	);
};
